import { Injectable } from '@angular/core';
import {
  BarcodeScanner,
  BarcodeFormat,
} from '@capacitor-mlkit/barcode-scanning';
import { ModalController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class BarcodeScannerService {

  constructor(private modalCtrl: ModalController) {}

  async isSupported(): Promise<boolean> {
    try {
      const result = await BarcodeScanner.isSupported();
      if (result.supported) return true;
    } catch { /* not on native */ }

    return !!(navigator.mediaDevices?.getUserMedia);
  }

  async scan(): Promise<string | null> {
    try {
      const result = await BarcodeScanner.isSupported();
      if (result.supported) {
        const granted = await this.requestPermission();
        if (!granted) return null;

        const scanResult = await BarcodeScanner.scan({
          formats: [
            BarcodeFormat.Ean13,
            BarcodeFormat.Ean8,
            BarcodeFormat.Code128,
            BarcodeFormat.Code39,
            BarcodeFormat.QrCode,
          ],
        });

        return scanResult.barcodes[0]?.rawValue ?? null;
      }
    } catch { /* fall through to web */ }

    const { BarcodeScanOverlayComponent } = await import(
      'src/app/components/order/barcode-scan-overlay/barcode-scan-overlay.component'
    );
    const modal = await this.modalCtrl.create({
      component: BarcodeScanOverlayComponent,
      cssClass: 'barcode-scan-modal',
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    return (data as { value: string } | undefined)?.value ?? null;
  }

  private async requestPermission(): Promise<boolean> {
    const status = await BarcodeScanner.requestPermissions();
    return status.camera === 'granted' || status.camera === 'limited';
  }
}
